import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class ContentDetail {
    constructor() {
        this.progressBar = $('#readingProgressBar');
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.bindScroll();
        this.injectRelatedRecipesWidget();
        this.injectRelatedContentWidget();

        $(window).on('resize', () => {
            this.injectRelatedRecipesWidget();
            this.injectRelatedContentWidget();
        });
    }

    bindScroll() {
        if (this.progressBar !== null && this.progressBar !== undefined) {
            window.addEventListener('scroll', () => {
                let scrollTop = window.scrollY;
                let docHeight = document.querySelector('.content-detail-content').offsetHeight + document.querySelector('.content-detail-related').offsetHeight; //document.body.offsetHeight;
                let winHeight = window.innerHeight;
                let scrollPercent = scrollTop / (docHeight - winHeight);
                let scrollPercentRounded = Math.round(scrollPercent * 100);
                if (scrollTop < 180)
                {
                    $(this.progressBar).hide();
                    $(this.progressBar).addClass('closed');
                } else {
                    $(this.progressBar).show();
                    $(this.progressBar).attr('value', scrollPercentRounded);
                    $(this.progressBar).removeClass('closed');
                }
            });
        }
    }

    injectRelatedContentWidget() {
        if ($('.widget--related-content-uplift') && $('.widget--related-content-uplift').length > 0) {
            // MOBILE
            if (Util.getViewPort() !== CONST.ViewPort.Desktop && $('#related-content-default-component')) {
                let sourceContent = $('#related-content-default-component').html();
                $('.widget--related-content-uplift').show();
                $('.widget--related-content-uplift').html(sourceContent);
                $('#related-content-default-component').hide();
            }
            // DESKTOP
            if (Util.getViewPort() === CONST.ViewPort.Desktop) {
                $('.widget--related-content-uplift').hide();
                $('#related-content-default-component').show();
            }   
        } 
    }

    injectRelatedRecipesWidget() {
        if ($('.widget--related-recipes-uplift') && $('.widget--related-recipes-uplift').length > 0) {
            // MOBILE
            if (Util.getViewPort() !== CONST.ViewPort.Desktop && $('#related-recipes-default-component')) {
                let sourceContent = $('#related-recipes-default-component').html();
                $('.widget--related-recipes-uplift').show();
                $('.widget--related-recipes-uplift').html(sourceContent);
                $('#related-recipes-default-component').hide();
            }
            // DESKTOP
            if (Util.getViewPort() === CONST.ViewPort.Desktop) {
                $('.widget--related-recipes-uplift').hide();
                $('#related-recipes-default-component').show();
            }   
        } 
    }
}

export default ContentDetail;

$(() => {
    const contentDetail = new ContentDetail();
    contentDetail.init();
});